export const radii = {
  xs: 2,
  s: 6,
  m: 8,
  l: 12,
  xl: 999,
  control: 8,
  card: 12,
  pill: 999,
} as const;
